import React from 'react';
import Scores from '../scores';
import TestDate from '../test-date';

const PreActForm = () => (
  <>
    <TestDate />
    <Scores min={1} max={35} />
  </>
);

export default PreActForm;
